import { useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import tripLogo from "../../assets/img/tripLogo.png";
import Upload from "../../assets/img/upload.png";

const TripForm = () => {
  const [previews, setPreviews] = useState({
    nationalId: null,
    birthCert: null,
    passport: null,
  });

  const [view, setView] = useState("form"); // form | loading | result
  const [extracted, setExtracted] = useState(null);

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setPreviews((prev) => ({ ...prev, [type]: url }));
    }
  };

  // پاکسازی URLهای موقت
  useEffect(() => {
    return () => {
      Object.values(previews).forEach((u) => u && URL.revokeObjectURL(u));
    };
  }, [previews]);

  const handleSmartFill = () => {
    // مخفی کردن فرم و نمایش لودینگ
    setView("loading");

    // شبیه‌سازی پردازش و استخراج اطلاعات (اینجا بعداً با API واقعی جایگزین کن)
    setTimeout(() => {
      setExtracted({
        firstName: "هانیه",
        lastName: "اطهری",
        nationalCode: "1234567890",
        birthDate: "1378/01/15",
        passportNo: "P1234567",
        fatherName: "مسعود",
        gender: "زن",
        issuePlace: "تهران",
      });
      setView("result");
    }, 1800);
  };

  const allSelected =
    previews.nationalId && previews.birthCert && previews.passport;

  const resetAll = () => {
    // بازگشت به فرم
    Object.values(previews).forEach((u) => u && URL.revokeObjectURL(u));
    setPreviews({ nationalId: null, birthCert: null, passport: null });
    setExtracted(null);
    setView("form");
  };

  return (
    <>
      <div className="min-h-screen h-full flex flex-col lg:h-full items-start bg-gray-100 tripBackgroud px-4 py-6">
        <div className="flex items-center mb-2 w-auto mx-auto mt-16">
          <img src={tripLogo} alt="Trip Logo" className="w-[50px] ml-2 " />
          <span className="font-Beiruti text-[#265069] text-[20px]">
            چت بات گردشگری
          </span>
        </div>

        <div className="w-[60%] mx-auto lg:w-full">
          <div className="bg-white rounded-3xl shadow-lg p-8 w-full mx-auto">
            {/* فرم آپلود */}
            {view === "form" && (
              <>
                <p className="font-IRANYekanMedium text-[14px] text-center mb-6 leading-7">
                  اینجا لازمه سه تا عکس از مدارکتو برامون آپلود کنی؛ مثل عکس کارت
                  ملی، صفحه اول شناسنامه و عکس پاسپورتت. ما با دستیار هوشمندمون
                  اطلاعات رو مستقیم از روی همین عکس‌ها استخراج می‌کنیم و فرم
                  اطلاعاتت رو برات تکمیل می‌کنیم. فقط کافیه هر کدوم رو بارگذاری
                  کنی و بقیه کارا رو بسپری به ما 😉
                </p>

                <div className="grid grid-cols-3 sm:grid-cols-3 gap-4">
                  {/* کارت ملی */}
                  <label className="flex flex-col items-center justify-center border border-dashed border-[#4490ba] rounded-2xl p-4 cursor-pointer hover:border-[#265069] transition relative bg-gray-50">
                    {previews.nationalId ? (
                      <img
                        src={previews.nationalId}
                        alt="preview"
                        className="w-full h-32 object-cover rounded-xl"
                      />
                    ) : (
                      <>
                        <img src={Upload} alt="" className="w-[25px] mb-2" />
                        <span className="text-[#265069] text-sm font-IRANYekanBold text-center">
                          بارگذاری تصویر کارت ملی
                        </span>
                      </>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) => handleFileChange(e, "nationalId")}
                    />
                  </label>

                  {/* شناسنامه */}
                  <label className="flex flex-col items-center justify-center border border-dashed border-[#4490ba] rounded-2xl p-4 cursor-pointer hover:border-[#265069] transition relative bg-gray-50">
                    {previews.birthCert ? (
                      <img
                        src={previews.birthCert}
                        alt="preview"
                        className="w-full h-32 object-cover rounded-xl"
                      />
                    ) : (
                      <>
                        <img src={Upload} alt="" className="w-[25px] mb-2" />
                        <span className="text-[#265069] text-sm font-IRANYekanBold text-center">
                          بارگذاری تصویر شناسنامه
                        </span>
                      </>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) => handleFileChange(e, "birthCert")}
                    />
                  </label>

                  {/* پاسپورت */}
                  <label className="flex flex-col items-center justify-center border border-dashed border-[#4490ba] rounded-2xl p-4 cursor-pointer hover:border-[#265069] transition relative bg-gray-50">
                    {previews.passport ? (
                      <img
                        src={previews.passport}
                        alt="preview"
                        className="w-full h-32 object-cover rounded-xl"
                      />
                    ) : (
                      <>
                        <img src={Upload} alt="" className="w-[25px] mb-2" />
                        <span className="text-[#265069] text-sm font-IRANYekanBold text-center">
                          بارگذاری تصویر پاسپورت
                        </span>
                      </>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) => handleFileChange(e, "passport")}
                    />
                  </label>
                </div>

                <button
                  onClick={handleSmartFill}
                  disabled={!allSelected}
                  className={`text-center w-auto mx-auto block font-IRANYekanExtra text-white px-4 py-2 rounded-lg mt-6 transition
                  ${allSelected ? "bg-[#0b94ca] hover:bg-[#f8b323]" : "bg-gray-300 cursor-not-allowed"}`}
                >
                  تکمیل هوشمند فرم !
                </button>
              </>
            )}

            {/* لودینگ */}
            {view === "loading" && (
              <div className="flex flex-col justify-center items-center h-[300px]">
                <ClipLoader size={40} color="#0b94ca" />
                <p className="mt-4 font-IRANYekanMedium text-[#0b94ca] text-[14px]">
                  در حال پردازش اطلاعات...
                </p>
              </div>
            )}

            {/* نتیجه: جدول اطلاعات استخراج‌شده */}
            {view === "result" && extracted && (
              <div className="space-y-4">
                <h3 className="font-IRANYekanBold text-[#265069] text-lg text-center">
                  اطلاعات هویتی استخراج‌شده ✔
                </h3>

                <div className="overflow-hidden rounded-2xl border p-5 border-[#cacaca]">
                  <table className="w-full text-sm">
                    <tbody className="[&>tr:nth-child(even)]:bg-gray-50">
                      <tr>
                        <td className="p-3 text-gray-500 w-40 font-IRANYekanExtra">نام</td>
                        <td className="p-3 font-IRANYekanMedium">{extracted.firstName}</td>
                      </tr>
                      <tr>
                        <td className="p-3 text-gray-500 font-IRANYekanExtra">نام خانوادگی</td>
                        <td className="p-3 font-IRANYekanMedium">{extracted.lastName}</td>
                      </tr>
                      <tr>
                        <td className="p-3 text-gray-500 font-IRANYekanExtra">کد ملی</td>
                        <td className="p-3 font-IRANYekanMedium">{extracted.nationalCode}</td>
                      </tr>
                      <tr>
                        <td className="p-3 text-gray-500 font-IRANYekanExtra">تاریخ تولد</td>
                        <td className="p-3 font-IRANYekanMedium">{extracted.birthDate}</td>
                      </tr>
                      <tr>
                        <td className="p-3 text-gray-500 font-IRANYekanExtra">شماره پاسپورت</td>
                        <td className="p-3 font-IRANYekanMedium">{extracted.passportNo}</td>
                      </tr>
                      <tr>
                        <td className="p-3 text-gray-500 font-IRANYekanExtra">نام پدر</td>
                        <td className="p-3 font-IRANYekanMedium">{extracted.fatherName}</td>
                      </tr>
                      <tr>
                        <td className="p-3 text-gray-500 font-IRANYekanExtra">جنسیت</td>
                        <td className="p-3 font-IRANYekanMedium">{extracted.gender}</td>
                      </tr>
                      <tr>
                        <td className="p-3 text-gray-500 font-IRANYekanExtra">محل صدور</td>
                        <td className="p-3 font-IRANYekanMedium">{extracted.issuePlace}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="flex items-center justify-center gap-3">
                  <button
                    onClick={resetAll}
                    className="px-4 py-2 xs:text-[10px] rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 font-IRANYekanMedium"
                  >
                   بارگذاری مجدد
                  </button>
                  <button className="px-4 py-2 xs:text-[10px] rounded-lg bg-[#0b94ca] hover:bg-[#f8b323] text-white font-IRANYekanExtra">
                    ثبت نهایی
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TripForm;
